<div class="product-card" [class.edit-mode]="isEditing">
  <div class="product-card-content">
    <div class="product-image">
      <img [src]="product?.imageUrl" alt="fragrance" height="142" width="142" loading="lazy"/>
    </div>
    <div class="product-content">
      @if(!isEditing){
        <div class="product-top-section">
          <div class="product-content__header">
            <span class="body-l-bold">{{ product?.name }}</span>
            <app-button [size]="'medium'" #triggerMenu="matMenuTrigger"
                        (menuClosed)="closePopup()"
                        (click)="openPopup()"
                        [matMenuTriggerFor]="requestActions" [iconPosition]="'left'" [type]="'tertiary'" [icon]="'more_vert'"></app-button>
          </div>
          <span class="body-s dark-alt-color">[{{ product?.sku }}]</span>
          <span class="body-m product-description truncate-text" [innerHTML]="product?.description"></span>
        </div>
        <div class="product-bottom-section">
          <div class="product-label-container">
            <span class="dark-alt-color body-m">Unit price</span>
            <span class="body-m">{{ product?.price?.value | defaultCurrency:product?.price?.currencyCode }}</span>
          </div>
          <div class="product-label-container">
            <span class="dark-alt-color body-m">Minimum Order Quantity (in Kg)</span>
            <span class="body-m">{{ product?.minQuantity }} Kg</span>
          </div>
        </div>
      }
      @else {
        <form [formGroup]="editForm">
          <div class="product-top-section">
            <div class="product-content__header">
              <span class="body-l-bold">{{ product?.name }}</span>
              <div class="product-header-actions">
                <app-button (click)="cancel()" iconPosition="left" type="tertiary" size="small" [icon]="'cancel'" text="Cancel"></app-button>
                <app-button (click)="saveProduct()" iconPosition="left" type="secondary" size="small" [icon]="'save'" text="Save"></app-button>
              </div>
            </div>
            <span class="body-s dark-alt-color">[{{ product?.sku }}]</span>
            <mat-form-field appearance="fill">
              <mat-label>Product Name</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Description</mat-label>
              <input matInput formControlName="description">
            </mat-form-field>
          </div>
          <div class="product-bottom-section">
            <div class="product-label-container">
              <mat-form-field appearance="fill">
                <mat-label>Price</mat-label>
                <input matInput type="number" formControlName="price">
              </mat-form-field>
            </div>
            <div class="product-label-container">
              <mat-form-field appearance="fill">
                <mat-label>Minimum Order Quantity (in Kg)</mat-label>
                <input matInput formControlName="minQuantity">
              </mat-form-field>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
  @if(product?.feedback) {
    <app-feedback-panel
      (reviewed)="handleReviewed()"
      [rating]="product?.feedback?.rating ?? 0"
      [comment]="product?.feedback?.comment"
      [createdAt]="product?.feedback?.createdAt"
      [waitingReview]="product?.isWaitingForReview"
      [shouldPanelOpen]="product?.isWaitingForReview ?? false"
      class="feedback-panel">
    </app-feedback-panel>
  }
</div>

<mat-menu #requestActions xPosition="after">
  <div (click)="$event.stopPropagation()" class="request-header-popup-wrapper">
    <a class="request-header-popup-item" (click)="editProduct()">
      <div class="content">
        <mat-icon>edit</mat-icon>
        <p class="body-m">Edit</p>
      </div>
    </a>
    <a class="request-header-popup-item" (click)="removeProduct()">
      <div class="content">
        <mat-icon>delete</mat-icon>
        <p class="body-m">Remove from selection</p>
      </div>
    </a>
  </div>
</mat-menu>
